import React from 'react'

import logger from '@/utils/logger'
import timezones from '@/utils/timeZones'
import timezonesDeprecated from '@/utils/timeZonesDeprecated'

import { TIMEZONE_DEFAULT } from '@/client/services/dateTime'

let UNKNOWN_TIMEZONE_WARNING = false

const deprecatedToNewZone: Record<string, string> = {}

Object.keys(timezonesDeprecated).forEach(newName => {
  timezonesDeprecated[newName].forEach(oldName => {
    deprecatedToNewZone[oldName] = newName
  })
})

export default function useLocalTimezone(): string | null {
  const [localTimezone, setLocalTimezone] = React.useState<string | null>(null)

  React.useEffect(() => {
    let detectedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

    if (!timezones.includes(detectedTimezone) && detectedTimezone in deprecatedToNewZone) {
      detectedTimezone = deprecatedToNewZone[detectedTimezone]
    }

    // Sometimes browsers have outdated IANA timezones
    // that we don't recognize. We don't want to put the
    // UI in an error state "automatically".
    if (timezones.includes(detectedTimezone)) {
      setLocalTimezone(detectedTimezone)
    } else {
      // Warn only once
      if (!UNKNOWN_TIMEZONE_WARNING) {
        UNKNOWN_TIMEZONE_WARNING = true
        logger.warning('Unknown browser timezone detected', {
          detectedTimezone,
        })
      }
      setLocalTimezone(TIMEZONE_DEFAULT)
    }
  }, [])

  return localTimezone
}
